module.exports = __webpack_public_path__ + "img/Tech-Chris-G-m.7ea9a93d.png";